/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/style-prop-object */
import Marquee from "react-fast-marquee";
import { FollowUsOnWrapper } from "../../styles/StyledComponents/FollowUsOnWrapper";
import { marqueeSlide } from "../../ui/json/demo.mock";
import CommonHeading from "../CommonHeading/CommonHeading";

const FollowUsOn = () => {
  return (
    <FollowUsOnWrapper className="cmn_gap">
      <div className="container">
        <CommonHeading
          isPrimary
          title="Follow Us On"
          className="follow_us_heading"
        />
        <Marquee autoFill={true}>
          {marqueeSlide.map((data, index) => (
            <div className="figureWrap">
              <figure key={index}>
                <img alt="" src={data} />
              </figure>
            </div>
          ))}
        </Marquee>

        <div className="maps_div">
          <iframe
            title="location of EMiiT"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7361.514009921421!2d88.38812807575417!3d22.700088028284842!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f89c0f4740d8cb%3A0x8be094d207426dbc!2sEMEI%20computer%20Institute!5e0!3m2!1sen!2sin!4v1748720959314!5m2!1sen!2sin"
            width="600"
            height="450"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </FollowUsOnWrapper>
  );
};

export default FollowUsOn;
